import { Label } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import { NAVIGATION_COOKIES_URL } from 'constants/catalog';
import { toggleOneTrustInfoDisplay } from 'libs/utils/window';
import OtherLink from '../OtherLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Privacy = () => {
  const translate = useTranslate('header.main_navigation.about.privacy');

  const handleCookiesClick = event => {
    event.preventDefault();
    toggleOneTrustInfoDisplay();
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Label, {
      styling: Label.Styling.Wide,
      text: translate('title')
    }), /*#__PURE__*/_jsx(OtherLink, {
      url: NAVIGATION_COOKIES_URL,
      title: translate('items.cookies'),
      onClick: handleCookiesClick
    })]
  });
};

export default Privacy;